import { useApi } from '../useApi';
import { prepareAuthHeaders } from '../requestsHelper';
import { baseUrl, ServiceName } from '../urlHelper';
import { CONSTANTS_PATH } from '../constant';
import { RequestResponseDTO } from '../../type/dto/RequestResponseDTO';

export const useGetRequestDetailsAPI = () => {
    const { apiCall } = useApi();

    const getRequestDetails = async (
        requestId: string,
        page: number = 0,
        size: number = 50
    ): Promise<RequestResponseDTO> => {
        const url: string = `${baseUrl(ServiceName.REQUESTS)}${CONSTANTS_PATH.REQUEST_SERVICE}/${requestId}`;

        return await apiCall<RequestResponseDTO>(url, {
            method: 'GET',
            headers: {
                ...prepareAuthHeaders(),
            },
            params: { page, size },
        });
    };

    return { getRequestDetails };
};

